

import React, { useState } from 'react';
import { doc, setDoc, addDoc, collection, getFirestore } from "firebase/firestore";
import { app } from './firebaseConfig';

const db = getFirestore(app);
const col = collection(db, 'quotes');

export const ContactUsForm = () => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);

    const handleSubmit = () => {
        if (name === '' || email === '' || phone === '' || message === '') {
            setSuccess(false);
            setError('Please fill out all fields');
        } else {
            addDoc(col, {
                to: ['nathancundall@gmail.com'], // Replace with your email
                message: {
                    subject: 'Request for quote on Website',
                    text: 'Name: ' + name + '\nEmail: ' + email + '\nPhone: ' + phone + '\nMessage: ' + message + '\n\n\nTHIS IS AN AUTOMATED EMAIL, DO NOT REPLY TO THIS EMAIL. CONTACT THE CLIENT DIRECTLY USING THE PROVIDED DETAILS.',
                    html: ''
                }
            })

            setName('');
            setEmail('');
            setPhone('');
            setMessage('');

            setSuccess(true);
            setError('Message has been sent, thank you');
        }
    }
    const errorClassName = success ? 'success-message' : 'error-message';
    return <div className="contact-us-form">
        <span className="header">Fill out the below form and we will be in touch</span>

        {error && <span className={errorClassName}>{error}</span>}
        <div className="form-field">
            <span>Your Name</span>
            <input type="text" value={name} onChange={(e) => setName(e.target.value)} />
        </div>
        <div className="form-field">
            <span>Your Email</span>
            <input type="text" value={email} onChange={(e) => setEmail(e.target.value)} />
        </div>
        <div className="form-field">
            <span>Your Phone number</span>
            <input type="text" value={phone} onChange={(e) => setPhone(e.target.value)} />
        </div>
        <div className="form-field">
            <span>Your Message</span>
            <textarea placeholder="We are looking to have our roof painted at 123 Example Street" value={message} onChange={(e) => setMessage(e.target.value)} rows={3} />
        </div>
        <button className="submit-button" onClick={handleSubmit}>Send Message</button>
    </div>
}